document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.best-sellers-swiper').forEach(function (swiperEl) {
    const swiperId = swiperEl.getAttribute('id');
    const wrapperEl = document.getElementById(swiperId + '-wrapper');

    if (!wrapperEl || !window.Swiper) return;
    if (swiperEl.swiper) return;

    // Behaviour comes from the section settings via data attributes on the wrapper. Every
    // fallback below is the value this carousel originally shipped with, so a missing or
    // unparseable attribute leaves it behaving exactly as before.
    const data = wrapperEl.dataset;

    const number = function (value, fallback) {
      const parsed = parseInt(value, 10);
      return isNaN(parsed) ? fallback : parsed;
    };

    // The timing settings are in seconds - Shopify caps a range setting's max below 10000, so
    // milliseconds cannot be expressed there. Swiper wants milliseconds.
    const milliseconds = function (value, fallbackMs) {
      const parsed = parseFloat(value);
      return isNaN(parsed) ? fallbackMs : Math.round(parsed * 1000);
    };

    // Checkboxes render as "true"/"false"; anything else (missing attribute) counts as on.
    const autoplayEnabled = data.autoplay !== 'false';
    const pauseOnHover = data.pauseOnHover !== 'false';
    const resumeDelay = milliseconds(data.resumeDelay, 1200);

    const swiper = new window.Swiper(swiperEl, {
      loop: true,
      speed: milliseconds(data.speed, 10000),
      autoplay: autoplayEnabled && {
        delay: milliseconds(data.delay, 0),
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      slidesPerView: number(data.slidesMobile, 2),
      spaceBetween: number(data.gapMobile, 50),
      breakpoints: {
        700: {
          slidesPerView: number(data.slidesDesktop, 4),
          spaceBetween: number(data.gapDesktop, 100),
        },
      },
    });

    if (!autoplayEnabled || !pauseOnHover) return;

    // Reads the transform the browser is painting RIGHT NOW, part-way through a transition.
    // swiper.translate only reports the destination, which is no use while gliding.
    const currentTranslateX = function () {
      const transform = window.getComputedStyle(swiper.wrapperEl).transform;
      if (!transform || transform === 'none') return swiper.translate;

      if (typeof window.DOMMatrixReadOnly === 'function') {
        return new window.DOMMatrixReadOnly(transform).m41;
      }

      const values = (transform.match(/\(([^)]+)\)/) || [, ''])[1].split(',').map(parseFloat);
      if (values.length >= 16) return values[12]; // matrix3d
      if (values.length >= 6) return values[4]; // matrix
      return swiper.translate;
    };

    let resumeTimer = null;
    let frozen = false;
    let movingSince = 0;
    let remainingMs = 0;

    // Timestamp each transition so a freeze can work out how much of it was left to run.
    swiper.on('transitionStart', function () {
      movingSince = Date.now();
    });

    // autoplay.stop() only cancels the timer for the NEXT slide; it does not halt the
    // transition already running. With "Pause between products" at 0 the carousel is one
    // continuous glide, so stopping the timer alone does nothing visible for up to a full
    // "Scroll speed". Pinning the live transform with a zero-length transition is what
    // actually stops it under the cursor.
    const freeze = function () {
      if (frozen) return;
      frozen = true;
      clearTimeout(resumeTimer);

      // How much of the interrupted transition was still to run. Resuming with this rather
      // than the full "Scroll speed" is what keeps the velocity constant: the leftover
      // distance gets the leftover time. Using the full duration for a part-slide is why a
      // resume looked slow when the freeze happened near a product boundary.
      const elapsed = movingSince ? Date.now() - movingSince : 0;
      remainingMs = Math.max(0, swiper.params.speed - elapsed);

      const position = currentTranslateX();
      swiper.autoplay.stop();
      swiper.setTransition(0);
      swiper.setTranslate(position);

      // We cut a transition short, so Swiper still thinks one is running. While
      // swiper.animating is true every later slideNext() is ignored, which makes autoplay
      // look dead on resume. Clear the flag and resync the index to the frozen position so
      // the next slide is computed from where the carousel actually stopped.
      swiper.animating = false;
      if (typeof swiper.updateActiveIndex === 'function') swiper.updateActiveIndex();
      if (typeof swiper.updateSlidesClasses === 'function') swiper.updateSlidesClasses();
    };

    const thaw = function () {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        if (!frozen) return;
        frozen = false;

        // Froze within a whisker of the boundary - nothing meaningful left to finish, so
        // just hand back to autoplay and let it start the next product cleanly.
        if (remainingMs < 50) {
          swiper.setTransition(swiper.params.speed);
          swiper.autoplay.start();
          return;
        }

        // Finish the interrupted move at its original velocity: leftover distance over
        // leftover time. Autoplay only restarts once that has landed, otherwise its own
        // tick fires a second slideNext and the two fight over the same transition.
        swiper.once('transitionEnd', function () {
          swiper.setTransition(swiper.params.speed);
          swiper.autoplay.start();
        });

        swiper.slideNext(remainingMs);
      }, resumeDelay);
    };

    swiperEl.addEventListener('mouseenter', freeze);
    swiperEl.addEventListener('mouseleave', thaw);
  });
});
